<template>
  <span v-show="isShowPage">
    <span class="page-sub-title">{{ table_title }}</span>
    <v-row align="center" justify="center">
      <v-col class="pb-0 pt-0" align-self="center">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          outlined
          solo
          hide-details
          v-model="search"
          class="search"
          placeholder="Search..."
          v-on:keyup.enter="getDataTable()"
        >
        </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="pb-0 pt-0" align-self="center">
        <v-btn
          color="primary"
          class="white--text ma-5 float-right"
          @click="exportExcel()"
        >
          Export Excel
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <Table :headers="headers" :loading="isFetching" :items="items" @onChangePage="getDataTable" @sortOptions="updateSortDatatable" :defaultSize="5">
          <template slot="statusDateSecondAgo" slot-scope="{ item }">
            {{ secondToHoursAndMinutes(item.statusDateSecondAgo) }}
          </template>
        </Table>
      </v-col>
    </v-row>
  </span>
</template>
<script>
import Table from '../../components/Table.vue'
import DashboardService from '@/services/DashboardService'

const dashboardService = DashboardService.build()
export default {
  name: 'UnavailableSPKLUDC',
  components: {
    Table
  },
  data: () => ({
    headers: [
      { value: 'number', text: 'No.', sortable: false, align: 'center', width: '80px' },
      { value: 'spkluName', text: 'Lokasi SPKLU', align: 'center', width: '150px' },
      { value: 'charger', text: 'Charger', align: 'center', width: '200px' },
      { value: 'statusName', text: 'Status', align: 'center', width: '130px' },
      { value: 'statusDateSecondAgo', text: 'Waktu Status', align: 'center', width: '130px' }
    ],
    items: {},
    search: '',
    sortSettings: '',
    isFetching: false, // for datatable
    isShowPage: false,
    table_title: '',
    timer: ''
  }),
  async created () {
    // delete localStorage
    localStorage.removeItem('tableQuery')
    this.table_title = this.$route.name
    this.isShowPage = true
  },
  computed: {},
  mounted: function () {
    if (this.$route.path === '/monitoring/unavailable-spklu-dc') {
      this.$nextTick(() => {
        // re-get data every 1 minute
        this.timer = setInterval(() => {
          this.resetData()
          const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
          if (tableQuery) {
            this.getDataTable(tableQuery.page, tableQuery.size)
          } else {
            this.getDataTable()
          }
        }, 60000)
      })
    }
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    search: function (val) {
      if (val === '') {
        this.getDataTable()
      }
    }
  },
  methods: {
    async resetData () {
      this.items = {}
      this.search = ''
      this.sortSettings = ''
    },
    async getDataTable (page, size) {
      // this.isFetching = true
      this.paging.page = page
      this.paging.size = size

      let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      localStorage.setItem('tableQuery', JSON.stringify({
        page: page,
        size: size,
        sort_by: tableQuery ? tableQuery.sort_by : ''
      }))

      // re-get data after set
      tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      const param = Object.assign({
        q: this.search,
        sort: tableQuery ? tableQuery.sort_by : ''
      }, this.paging)

      const response = await dashboardService.getDetailUnavailableDC(param)
      if (response.data.status === 401) {
        alert.breaksession()
      }
      if (response.data.status === 200) {
        const { data: { data: { content, totalPages, number, size, totalElements } } } = response
        this.items = Object.assign({
          data: content,
          total: totalPages,
          size,
          page: number + 1,
          totalElements
        })
      } else {
        alert.failed(response.data.status + ' - ' + response.data.message)
      }
      // this.isFetching = false
    },
    async updateSortDatatable (options) {
      if (options.sortBy) {
        this.sortSettings = ''
        for (let i = 0; i < options.sortBy.length; i++) {
          const sort = options.sortDesc[i] === false ? 'asc' : 'desc'
          let column = ''

          if (options.sortBy[i] === 'spkluName') {
            column = 'spkluName'
          } else if (options.sortBy[i] === 'charger') {
            column = 'charger'
          } else if (options.sortBy[i] === 'statusName') {
            column = 'statusName'
          } else if (options.sortBy[i] === 'statusDateSecondAgo') {
            column = 'statusDateSecondAgo'
          }

          if (i === 0) {
            this.sortSettings += column + ',' + sort
          } else {
            this.sortSettings += '&sort=' + column + ',' + sort
          }
        }

        let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        localStorage.setItem('tableQuery', JSON.stringify({
          page: tableQuery ? tableQuery.page : 0,
          size: tableQuery ? tableQuery.size : 20,
          sort_by: this.sortSettings
        }))
        tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        this.getDataTable(tableQuery.page, tableQuery.size)
      }
    },
    async exportExcel () {
      const param = {
        name: 'Data Unavailable SPKLU Zona 1 ' + new Date() + '.xlsx'
      }
      await dashboardService.getDetailUnavailableDCExcel(param)
    }
  }
}
</script>
<style scoped>
</style>
